"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("../_internal/utils");
var identity_1 = tslib_1.__importDefault(require("../identity"));
var map_1 = tslib_1.__importDefault(require("./map"));
function concurrentPool(length, iterable) {
    var _a;
    if (iterable === undefined) {
        return function (iterable) {
            return concurrentPool(length, iterable);
        };
    }
    if (!Number.isFinite(length) || length <= 0) {
        throw new RangeError("'length' must be positive integer");
    }
    if (!(0, utils_1.isAsyncIterable)(iterable)) {
        throw new TypeError("'iterable' must be type of AsyncIterable");
    }
    if (length === 1) {
        return (0, map_1.default)(identity_1.default, iterable);
    }
    var fillId = 1;
    var consumeId = 1;
    var idleWorkers = length;
    var consumer = [];
    var itemMap = new Map();
    var iterator = iterable[Symbol.asyncIterator]();
    var finished = false;
    var prev = Promise.resolve();
    function fetchNextItem() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, item, error_1, item;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (idleWorkers <= 0) {
                            return [2 /*return*/];
                        }
                        idleWorkers--;
                        id = fillId++;
                        fillId = fillId % Number.MAX_SAFE_INTEGER;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = {};
                        return [4 /*yield*/, iterator.next()];
                    case 2:
                        item = (_a.success = _b.sent(),
                            _a);
                        idleWorkers++;
                        itemMap.set(id, item);
                        chainItem(item);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        idleWorkers++;
                        finished = true;
                        item = {
                            success: { done: false },
                            fail: error_1,
                        };
                        itemMap.set(id, item);
                        chainItem(item);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function chainItem(item) {
        prev = prev.then(function () { return item; }).then(pullItem);
        return item;
    }
    function doneQueue() {
        while (consumer.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _a = tslib_1.__read(consumer.shift(), 1), resolve = _a[0];
            resolve({
                value: undefined,
                done: true,
            });
        }
    }
    function pullItem(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, _a, resolve, reject, value;
            return tslib_1.__generator(this, function (_b) {
                while (consumer.length > 0) {
                    id = consumer[0][2];
                    if (!itemMap.has(id)) {
                        break;
                    }
                    _a = tslib_1.__read(consumer.shift(), 2), resolve = _a[0], reject = _a[1];
                    value = itemMap.get(id);
                    itemMap.delete(id);
                    if (value.fail) {
                        reject(value.fail);
                        doneQueue();
                    }
                    else {
                        resolve(value.success);
                    }
                }
                /**
                 * @TODO ppeeou: If an error occurs, the next iterator should not be executed
                 */
                if (!item.success.done && consumer.length > 0) {
                    fetchNextItem();
                }
                return [2 /*return*/];
            });
        });
    }
    function processQueue() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (idleWorkers == 0) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, Promise.all(Array.from({ length: idleWorkers }, function () { return fetchNextItem(); }))];
            });
        });
    }
    function slide() {
        if (finished && fillId === consumeId) {
            while (consumer.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var _a = tslib_1.__read(consumer.shift(), 1), resolve = _a[0];
                resolve({ value: undefined, done: true });
            }
        }
        else {
            processQueue();
        }
    }
    return _a = {},
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a.next = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var id = consumeId++;
                            consumeId = consumeId % Number.MAX_SAFE_INTEGER;
                            var task = [resolve, reject, id];
                            consumer.push(task);
                            slide();
                        })];
                });
            });
        },
        _a;
}
exports.default = concurrentPool;
//# sourceMappingURL=concurrentPool.js.map